
export const ConstantEventEmitter = {
    eventCheckBoxTable: "EVENT_CB_TABLE",
    eventCheckBoxTableMasterDetail: "EVENT_CB_TABLE_MASTER_DETAIL",
    eventSwitchTable: "EVENT_SWITCH_TABLE",
    eventActionsTable: "EVENT_ACTIONS_TABLE",
    eventCrudModalTable: "EVENT_OPEN_CRUD_MODAL",
    eventDeleteTable: "DELETE_ROW_TABLE",
    eventChangeProductosSustitutos: "EVENT_CHANGE_PRODUCTOS_SUSTITUTOS",
    eventCloseModalDiasEntregaVisita: "EVENT_CHANGE_MODAL_STATE_DIAS_ENTREGA",
    eventChangeTab: "EVENT_CHANGE_TAB_DYNAMIC",
    keyActionsTableEdit: "EDIT",
    keyActionsTableDelete: "DELETE",
    keyActionsTableView: "VIEW",
    keyActionsTablePtoVenta: "PUNTO_VENTA",
    keyActionsTableChangePasswordUsers: "CHANGE_PASSWORD_USERS",
    keyActionsTableCreatePasswordUsers: "CREATE_PASSWORD_USERS",
    keyActionsEditTreeMenuAdmin: "EDIT_MENU_ADMIN",
    keyActionsUpdateHeaderInfoCliente: "UPDATE_HEADER_INFO_CLIENTE",
    keyActionsFilterCriteriosPuntoVenta: "FILTER_PUNTOS_VENTA_ITEM",
    keyActionsUpdatePuntoVentaItem: "UPDATE_PUNTOS_VENTA_ITEM",
    keyEmitFilterPortafolios: "FILTER_PORTAFOLIOS",
    handleClickTabTracker: "CLICK_TAB_TRACKER",
    handleClickNextTabTracker: "CLICK_NEXT_TAB_TRACKER",
    handleClickBackTabTracker: "CLICK_BACK_TAB_TRACKER",
    handleClickViewSubportafolios: "CLICK_VIEW_SUBPORTAFOLIOS",
    handleClickViewSubportafoliosSave: "CLICK_VIEW_SUBPORTAFOLIOS_SAVE",
    handleClickViewProductosBySubportafolio: "CLICK_VIEW_PRODUCTOS_SUBPORTAFOLIOS",
    handleClickViewProductosBySubportafolioSave: "CLICK_VIEW_PRODUCTOS_SUBPORTAFOLIOS_SAVE",
    handleUpdateCounterItemsPortafoliosComercial: "handleUpdateCounterItemsPortafoliosComercial",
    handleUpdateCounterItemsPortafoliosMaterial: "handleUpdateCounterItemsPortafoliosMaterial",
    handleUpdateCRUDPortafoliosComercial: "handleUpdateCRUDPortafoliosComercial",
    handleUpdateCRUDPortafoliosMaterial: "handleUpdateCRUDPortafoliosMaterial",
    eventUpdateOptionsPortafoliosComerciales: "eventUpdateOptionsPortafoliosComerciales",
    eventUpdateDataPortafoliosComercialesFromModal: "eventUpdateDataPortafoliosComercialesFromModal",
  eventUpdateDataPortafoliosMaterialesFromModal: "eventUpdateDataPortafoliosMaterialesFromModal",
}
